/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderDetailKoreaTrackVo
 */
export interface OrderDetailKoreaTrackVo {
    /**
     * 主键id
     * @type {number}
     * @memberof OrderDetailKoreaTrackVo
     */
    id?: number;
    /**
     * 订单id
     * @type {number}
     * @memberof OrderDetailKoreaTrackVo
     */
    orderId?: number;
    /**
     * 运输公司编码
     * @type {string}
     * @memberof OrderDetailKoreaTrackVo
     */
    transportCompanyCode?: string;
    /**
     * 是否主运单  1 是 0 不是
     * @type {number}
     * @memberof OrderDetailKoreaTrackVo
     */
    main?: number;
    /**
     * 运单号
     * @type {string}
     * @memberof OrderDetailKoreaTrackVo
     */
    trackingNumber?: string;
}

/**
 * Check if a given object implements the OrderDetailKoreaTrackVo interface.
 */
export function instanceOfOrderDetailKoreaTrackVo(value: object): value is OrderDetailKoreaTrackVo {
    return true;
}

export function OrderDetailKoreaTrackVoFromJSON(json: any): OrderDetailKoreaTrackVo {
    return OrderDetailKoreaTrackVoFromJSONTyped(json, false);
}

export function OrderDetailKoreaTrackVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDetailKoreaTrackVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'transportCompanyCode': json['transportCompanyCode'] == null ? undefined : json['transportCompanyCode'],
        'main': json['main'] == null ? undefined : json['main'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
    };
}

export function OrderDetailKoreaTrackVoToJSON(json: any): OrderDetailKoreaTrackVo {
    return OrderDetailKoreaTrackVoToJSONTyped(json, false);
}

export function OrderDetailKoreaTrackVoToJSONTyped(value?: OrderDetailKoreaTrackVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderId': value['orderId'],
        'transportCompanyCode': value['transportCompanyCode'],
        'main': value['main'],
        'trackingNumber': value['trackingNumber'],
    };
}

